const periodConversion = {
    convertPeriod: function (period) {

        if (period == "CAL") {
            return "Calendar";
        }
        if (period == "Jan") {
            return "January";
        }
        if (period == "Feb") {
            return "February";
        }
        if (period == "Mar") {
            return "March";
        }
        if (period == "Apr") {
            return "April";
        }

        if (period == "May") {
            return "May";
        }

        if (period == "Jun") {
            return "June";
        }
        
        if (period == "Jul") {
            return "July";
        }

        if (period == "Aug") {
            return "August";
        }
        
        if (period == "Sep") {
            return "September";
        }

        if (period == "Oct") {
            return "October";
        }

        if (period == "Nov") {
            return "November";
        }

        if (period == "Dec") {
            return "December";
        }
        if (period == "Sum") {
            return "Summer";
        }

        if (period == "Win") {
            return "Winter";
        }


    }
}

export default periodConversion;